// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const buildTimestamp = new Date().toISOString();
